import {ZodError} from 'zod';

export const transformZodErrors = (zodErrors: ZodError['errors']): Record<string, string[]> => {
    const errorMap: Record<string, string[]> = {};
    zodErrors.forEach((error) => {
        const field = error.path[0] as string;
        if (!errorMap[field]) {
            errorMap[field] = [];
        }
        errorMap[field].push(error.message);
    });
    return errorMap;
};
